import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "match-lesser-3",
  "use": "match-lesser-3-usage",
  "viewBox": "0 0 106.6 190.36",
  "content": "<symbol viewBox=\"0 0 106.6 190.36\" id=\"match-lesser-3\"><path class=\"a\" d=\"M49.32 9.72h17.45v39.33a2.41 2.41 0 0 0-.15.83v5.5a2.07 2.07 0 0 0 2.11 2.11H92v4.73l14.6-9.3-14.6-9.3v4.15H77.88v-40-5.66A2.06 2.06 0 0 0 75.8 0H49.31a2 2 0 0 0-2.09 2.11v5.5a2.06 2.06 0 0 0 2.1 2.11zM92 132.88H68.73a2.06 2.06 0 0 0-2.11 2.1v5.51a2.51 2.51 0 0 0 .15.83v39.32H49.32a2.06 2.06 0 0 0-2.1 2.11v5.51a2.06 2.06 0 0 0 2.1 2.1h26.47a2.06 2.06 0 0 0 2.11-2.1v-5.51-40.17H92v4.15l14.6-9.3-14.6-9.28zM92 88.91H52.32a2.06 2.06 0 0 0-2.1 2.09v5.5a2.06 2.06 0 0 0 2.1 2.11H92v4.15l14.6-9.3L92 84.18zm-14.12 9.68z\" /><path class=\"b\" d=\"M77.88 99.59h1.43M.77 110.64H0\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/match-lesser-3.svg
// module id = R2Sb
// module chunks = 1